const MemberTable = ({ members = [] }) => {
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">

      <div className="border-b px-6 py-4">
        <h2 className="text-lg font-semibold text-slate-800">
          Team Members
        </h2>

        <p className="mt-1 text-sm text-slate-500">
          Members assigned across project workspaces
        </p>
      </div>

      {members.length === 0 ? (
        <div className="p-10 text-center">
          <p className="text-sm text-slate-500">
            No members assigned to this project.
          </p>
        </div>
      ) : (
        <div className="overflow-x-auto">

          <table className="min-w-full">

            <thead className="bg-slate-50">
              <tr>
                <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600">
                  Member
                </th>

                <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600">
                  Role
                </th>

                <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600">
                  Workspace
                </th>

                <th className="px-6 py-4 text-left text-sm font-semibold text-slate-600">
                  Status
                </th>
              </tr>
            </thead>

            <tbody>
              {members.map((member) => (
                <tr
                  key={member.uuid}
                  className="border-t border-slate-100"
                >

                  {/* MEMBER */}

                  <td className="px-6 py-4">
                    <div>
                      <p className="font-semibold text-slate-800">
                        {member.name}
                      </p>

                      {member.email && (
                        <p className="text-xs text-slate-500">
                          {member.email}
                        </p>
                      )}
                    </div>
                  </td>

                  {/* ROLE */}

                  <td className="px-6 py-4">
                    <span className="text-sm text-slate-700">
                      {member.role || "Member"}
                    </span>
                  </td>

                  {/* WORKSPACES */}

                  <td className="px-6 py-4">
                    <div className="flex flex-wrap gap-2">

                      {member.workspaces?.map(
                        (workspace) => (
                          <span
                            key={workspace.uuid}
                            className="rounded-full bg-purple-100 px-3 py-1 text-xs font-medium text-purple-700"
                          >
                            {workspace.name}
                          </span>
                        )
                      )}

                    </div>
                  </td>

                  {/* STATUS */}

                  <td className="px-6 py-4">
                    <span
                      className={`rounded-full px-3 py-1 text-xs font-medium ${
                        member.status === "Active"
                          ? "bg-green-100 text-green-700"
                          : member.status === "Planned"
                          ? "bg-yellow-100 text-yellow-700"
                          : "bg-slate-100 text-slate-600"
                      }`}
                    >
                      {member.status || "Active"}
                    </span>
                  </td>

                </tr>
              ))}
            </tbody>

          </table>

        </div>
      )}
    </div>
  );
};

export default MemberTable;